import type {WorkloadScore} from "../../4-scoring/performScoring.ts";
import type {Workload} from "../../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../../3-workload-analysis/model/WorkloadInput.ts";
import {DownloadWorkloadButton} from "./DownloadWorkloadButton.tsx";

/**
 * Render a single recommended workload item
 */
function RecommendedWorkloadItem({
    workloadScore,
    getWorkloadInput,
    index
}: {
    workloadScore: WorkloadScore
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
    index: number
}) {
    const workload = workloadScore.workload
    const descriptions = workloadScore.score.description || []
    
    return (
        <li key={index}>
            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem'}}>
                <strong>
                    {workload.versionId.groupName}/{workload.versionId.projectName}/{workload.versionId.versionName} - {workload.startingJob}
                </strong>
                {' '}({workload.tasks.length} execution{workload.tasks.length !== 1 ? 's' : ''})
                <DownloadWorkloadButton
                    workload={workload}
                    getWorkloadInput={getWorkloadInput}
                    label="Download"
                />
            </div>
            {descriptions.length > 0 && (
                <ul>
                    {descriptions.map((desc, descIdx) => (
                        <li key={descIdx}>{desc}</li>
                    ))}
                </ul>
            )}
        </li>
    )
}

/**
 * Render the recommendations list
 */
export function RecommendationsList({
    workloadScores,
    getWorkloadInput
}: {
    workloadScores: WorkloadScore[]
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
}) {
    if (workloadScores.length === 0) {
        return <p><em>No recommendations available.</em></p>
    }

    return (
        <ul>
            {workloadScores.map((workloadScore, idx) => (
                <RecommendedWorkloadItem
                    key={idx}
                    workloadScore={workloadScore}
                    getWorkloadInput={getWorkloadInput}
                    index={idx}
                />
            ))}
        </ul>
    )
}
